import { css, type Theme } from '@emotion/react';

export const content = (theme: Theme) => css`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 280px;
  padding: 16px;
`;

export const header = css`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const subtitle = (theme: Theme) => css`
  color: ${theme.colors.gray[500]};
`;

export const columnsList = css`
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-height: 320px;
  overflow: auto;
`;

export const actions = css`
  display: flex;
  justify-content: flex-end;
  gap: 8px;
`;
